<script lang="ts">
  import { getCopy } from "../../lib/stores/copy";
  import BaseCard from "../Card/BaseCard.svelte";
  import { navigateToPath } from "../../lib/routing";
  import PATHS from "../../lib/constants/routePaths";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import Typography from "../Typography.svelte";
  import { getCampaignUser } from "../../lib/helpers/campaignUserManager";
  import LoadingScreen from "../LoadingScreen.svelte";
  import { formatMultiSelectionVariations, groupMultipleSelectionItems, type MultiSelectVisibleData } from "../../lib/helpers/steps/bundleSelection";
  import { onMount } from "svelte";

  export let hideEditButton: boolean = false;
  let isLoading = true;
  let image: string | undefined;
  let items: MultiSelectVisibleData[] = [];

  onMount(async () => {
    isLoading = true;
    const campaignUser = await getCampaignUser(); // Should be immediate when going through the flow
    // image = campaignUser?.metadata?.social_gift_bundle?.image; // FIXME: we definitely need some default artwork...
    items = groupMultipleSelectionItems(campaignUser?.metadata?.available_menu_items || []);
    isLoading = false;
  });

  const onEditClick = () => navigateToPath(PATHS.MENU);

  $: copy = $getCopy("review") as Record<string, string>;
</script>

<BaseCard headerCopy={copy.selectedGiftHeaderCopy} {onEditClick} {hideEditButton}>
  <svelte:fragment slot="card body">
    {#if isLoading}
      <LoadingScreen />
    {:else}
      <div class="flex flex-row gap-4">
        {#if image}
          <div
            class="bg-cover bg-center rounded-lg block h-20 w-20"
            role="img"
            aria-label={image}
            style={`background-image: url("${image}");`}>
          </div>
        {/if}
        <div class="flex flex-col gap-3 justify-start">
          <div class="flex flex-col">
            {#each items as item}
              <Typography mobile={TypographyType.Body1Medium} desktop={TypographyType.Headline5Medium}>
                1x {item.visibleName}
                {formatMultiSelectionVariations(item)}
              </Typography>
            {/each}
          </div>
        </div>
      </div>
    {/if}
  </svelte:fragment>
</BaseCard>
